module.exports = __webpack_public_path__ + "img/odonto_emergenza_implantologia_nucleo.6ffc93dd.jpg";